<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Request Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="request_date_from"/> ~ <CustomDatePicker v-model="request_date_to"/></span>

				<span class="int_type_no_border mgr_5">
					<!-- <input type="text" class="int_type ssm_int" v-model="ship_to_code" placeholder="Ship To" autocomplete="off" @click="selectPartner('ship')" /> -->
					<PartnerSelect v-model="partner_code" ph="Partner" :showName="false" @set-partner="setPartner" />
				</span>
				<em class="lt_text">Status</em>
				<span class="int_type mgr_15">
					<select v-model="sc_status_code">
						<option value="">All</option>
						<option v-for="tag in this.$scStatusCodes" v-bind:value="tag.code" v-bind:key="tag.code">{{ tag.name }}</option>
					</select>
				</span>

				<em class="lt_text">A/R Credit Type</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="arCreditTypeList" v-model="ar_credit_type_code"/></span>

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sales_group_code"/></span>
				<span class="int_type sm_int">
					<input type="text" v-model.trim="keyword" placeholder="Barcode Scan or SC No" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable>
			<thead>
				<tr>
					<th width="6%">
						<a href="javascript:;" @click="sort('sc_no')">SC No{{ sortMark('sc_no') }}</a>
					</th>
					<th width="5%">Partner Code</th>
					<th width="15%">Partner Name</th>
					<th width="8%">A/R Credit Type</th>
					<th width="8%">Sales Group</th>
					<th width="6%">Status</th>
					<th width="6%">Request Date</th>
					<th width="6%">
						<a href="javascript:;" @click="sort('confirm_date')">Confirm Date{{ sortMark('confirm_date') }}</a>
					</th>
					<th width="6%">Used Date</th>
					<th width="5%">Amount</th>
					<th width="6%">Entry</th>
					<th>Info</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="sc in store_credits" v-bind:key="sc.sc_no">
					<td class="al_left">
						<a href="javascript:;" @click="selectStoreCredit(sc)">{{ sc.sc_dn }}</a>
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="gotoPartner(sc.partner_code)">{{ sc.partner_code }}</a>
					</td>
					<td class="al_left truncate">
						<a href="javascript:;" @click="gotoPartner(sc.partner_code)">{{ sc.partner_name }}</a>
					</td>
					<td class="al_left">{{ sc.ar_credit_type_name }}</td>
					<td class="al_left">{{ sc.sales_group_name }}</td>
					<td class="al_center">{{ sc.status_code | scStatusName }}</td>

					<td class="al_center">{{ sc.request_date }}</td>
					<td class="al_center">{{ sc.confirm_date }}</td>
					<td class="al_center">{{ sc.used_date }}</td>

					<td class="al_right">{{ sc.amount | toCurrency }}</td>
					<td class="al_left">{{ sc.crt_user }}</td>
					<td class="al_left truncate">{{ sc.info }}</td>
				</tr>
				<tr>
					<td colspan="9" class="al_right"><font color="red">Total</font></td>

					<td class="al_right">
						<font color="red">{{ total_amount_sum | toCurrency }}</font>
					</td>
					<td></td>
					<td></td>
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<li><a href="javascript:void(0);" @click="excelExport">Excel</a></li>
			</ul>
			<ul>
				<li v-if="modifiable"><router-link :to="{ name: 'scDetail', params: { mode: 'add' }, query: { backUri: this.uri } }">Add</router-link></li>
			</ul>
		</div>

		<!-- <Modal @close="closeModal" v-if="showModal && modalName == 'PartnerSelect'" :draggable="false">
			<template slot="title">Select Partner</template>
			<template slot="body">
				<PartnerPopup v-on:close="closeModal()" @set-partner="setPartner" />
			</template>
		</Modal> -->
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectStoreCreditList } from '@/api/partner/storecredit.js';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
//import Modal from '@/components/common/Modal';
import { daysAgo, today } from '@/utils/date.js';
import { exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			sc_status_code: '',
			request_date_from: daysAgo(365),
			request_date_to: today(),
			sales_group_code: null,
			ar_credit_type_code: null,

			partner_code: null,
			keyword: null,

			salesGroups: [],
			arCreditTypeList: [],

			store_credits: [],

			// modalName: '',
			// showModal: false,

			total_amount_sum: 0,
			search_param: {},

			sort_key: null,
			sort_direction: 'ASC',
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		CodeSelect,
		PartnerSelect,
	},
	methods: {
		selectStoreCredit(store_credit) {
			// if (invoice.invoice_type == 'R') {
			// 	this.$toast.warning('Return SO will be developed later.');
			// 	return;
			// }
			//console.log(invoice);
			this.$router.push({ name: 'scDetail', params: { mode: 'detail' }, query: { backUri: this.uri, sc_no: store_credit.sc_no } });
		},
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectStoreCredits();
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectStoreCredits(pageNo);
		},
		// setSalesGroup(code) {
		// 	if (code) this.sales_group_code = code.code;
		// 	else this.sales_group_code = null;
		// },
		setPartner(partner) {
			//console.log(partner.code, partner.name);
			this.partner_code = partner.code;

			this.search();
		},

		reset() {
			// this.sort_key = 'code';
			// this.sort_direction = 'ASC';

			//this.invoice_type = 'S';
			this.sc_status_code = null;
			(this.ar_credit_type_code = null), (this.request_date_from = daysAgo(365));
			this.request_date_to = today();
			this.sales_group_code = null;
			this.partner_code = null;
			this.keyword = null;

			//this.search();

			//this.selectInvoices();
			// this.dept_code = null;
		},
		async search() {
			await this.selectStoreCredits();
			//if (this.invoices.length == 1 && this.keyword) this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: this.invoices[0].invoice_no } });
		},
		async selectStoreCredits(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			//console.log('select invoices');
			//const { data } = await selectAllPensioner();
			if (this.keyword) {
				this.$toast.warning('Search by Store Credit No.');
				this.search_param = {
					paging_yn: this.paging_yn,
					page_size: this.page_size,
					page_no: this.page_no,
					start_index: this.page_size * (this.page_no - 1),

					keyword: this.keyword,
				};
			} else {
				this.search_param = {
					paging_yn: this.paging_yn,
					page_size: this.page_size,
					page_no: this.page_no,
					start_index: this.page_size * (this.page_no - 1),

					status_code: this.sc_status_code,
					request_date_from: this.request_date_from,
					request_date_to: this.request_date_to,
					ar_credit_type_code: this.ar_credit_type_code,
					sales_group_code: this.sales_group_code,
					partner_code: this.partner_code,

					sort_key: this.sort_key,
					sort_direction: this.sort_direction,
				};
			}

			const { data } = await apiSelectStoreCreditList(this.search_param);
			// this.pensioners = data;
			// if (this.pensioners.length > 0 && this.selectedPsNo == null) {
			// 	this.selectRow(this.pensioners[0]);
			// }
			//console.log(data);
			this.store_credits = data.storeCreditList;
			//this.list_count = data.list_count; //data.list_count;
			this.list_count = data.storeCreditListSum.list_count;
			//console.log(data.storeCreditListSum);
			this.total_amount_sum = data.storeCreditListSum.amount;
			//this.total_amount_sum = data.invoicesSum.total_amount_sum;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/sc/sc_main?page_no=' + this.page_no;
			if (this.keyword) uri += '&keyword=' + this.keyword;
			if (this.status_code) uri += '&status_code=' + this.status_code;
			if (this.request_date_from) uri += '&request_date_from=' + this.request_date_from;
			if (this.request_date_to) uri += '&request_date_to=' + this.request_date_to;
			if (this.ar_credit_type_code) uri += '&ar_credit_type_code=' + this.ar_credit_type_code;
			if (this.sales_group_code) uri += '&sales_group_code=' + this.sales_group_code;
			if (this.partner_code) uri += '&partner_code=' + this.partner_code;
			if (this.sort_key) uri += '&sort_key=' + this.sort_key;
			if (this.sort_direction) uri += '&sort_direction=' + this.sort_direction;
			//this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);

			if (this.list_count == 1 && this.keyword) {
				this.selectStoreCredit(this.store_credits[0]);
			}
		},
		async excelExport() {
			let { data } = await apiSelectStoreCreditList({
				paging_yn: 'N',
				page_size: 0,
				page_no: 0,
				start_index: 0,

				status_code: this.search_param.status_code,
				request_date_from: this.search_param.request_date_from,
				request_date_to: this.search_param.request_date_to,
				ar_credit_type_code: this.search_param.ar_credit_type_code,
				sales_group_code: this.search_param.sales_group_code,
				partner_code: this.search_param.partner_code,

				sort_key: this.search_param.sort_key,
				sort_direction: this.search_param.sort_direction,

				keyword: this.search_param.keyword,
			});

			let sc_list = data.storeCreditList || [];
			let sc_sum = data.storeCreditListSum || {};
			sc_list.forEach(sc => {
				let idx = this.$scStatusCodes.findIndex(c => sc.status_code === c.code);
				if (idx > -1) sc.status_name = this.$scStatusCodes[idx].name;
				else sc.status_name = '';

				// Str: mm-dd-yyyy -> Date Object
				// sc.request_date = toDate(sc.request_date);
				// sc.confirm_date = toDate(sc.confirm_date);
				// sc.used_date = toDate(sc.used_date);
			});
			sc_list.push({ sc_dn: 'TOTAL', partner_code: '', partner_name: '', ar_credit_type_name: '', sales_group_name: '', request_date: null, confirm_date: null, used_date: null, amount: sc_sum.amount, crt_user: '', info: '' });

			let headers = [
				{ key: 'sc_dn', name: 'SC No', width: 15, dataType: defaultDataType.string },
				{ key: 'partner_code', name: 'Partner Code', width: 15, dataType: defaultDataType.string },
				{ key: 'partner_name', name: 'Partner Name', width: 40, dataType: defaultDataType.string },
				{ key: 'ar_credit_type_name', name: 'A/R Credit Type', width: 15, dataType: defaultDataType.string },
				{ key: 'sales_group_name', name: 'Sales Group', width: 15, dataType: defaultDataType.string },
				{ key: 'status_name', name: 'Status', width: 15, dataType: defaultDataType.string },
				{ key: 'request_date', name: 'Request Date', width: 15, dataType: defaultDataType.string },
				{ key: 'confirm_date', name: 'Confirm Date', width: 15, dataType: defaultDataType.string },
				{ key: 'used_date', name: 'Used Date', width: 15, dataType: defaultDataType.string },
				{ key: 'amount', name: 'Amount', width: 15, dataType: defaultDataType.number },
				{ key: 'crt_user', name: 'Entry', width: 15, dataType: defaultDataType.string },
				{ key: 'info', name: 'Info', width: 45, dataType: defaultDataType.string },
			];

			exportDataExcel(sc_list, headers, `Store Credit(${this.search_param.request_date_from}_${this.search_param.request_date_to})`);
		},
		gotoPartner(code) {
			//console.log(code);
			this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
		},
		async index() {
			const { data } = await apiIndex();

			this.salesGroups = data.salesGroupList;
			this.arCreditTypeList = data.arCreditTypeList;
		},
		async init() {
			await this.index();

			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.status_code) this.status_code = this.$route.query.status_code;
			if (this.$route.query.request_date_from) this.request_date_from = this.$route.query.request_date_from;
			if (this.$route.query.request_date_to) this.request_date_to = this.$route.query.request_date_to;
			if (this.$route.query.sales_group_code) this.sales_group_code = this.$route.query.sales_group_code;
			if (this.$route.query.ar_credit_type_code) this.ar_credit_type_code = this.$route.query.ar_credit_type_code;
			if (this.$route.query.partner_code) this.ship_to_code = this.$route.query.partner_code;
			if (this.$route.query.sort_key) this.sort_key = this.$route.query.sort_key;
			if (this.$route.query.sort_direction) this.sort_direction = this.$route.query.sort_direction;

			await this.selectStoreCredits(this.$route.query.page_no);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 8);

		this.$store.commit('setSelectedMenu', 'nav_li_sc_main');
		this.$store.commit('setSubTitle', 'Store Credit');

		this.init();
	},
	mounted() {
		inputSelectOnClick();
		//makeTableResizable();
	},
};
</script>

<style></style>
